import React from 'react';
import './styles.css';
import PropTypes from 'prop-types';

// fake 'event' to toggle any AND/OR property to the other value
const toggleAndOr = {
  OR: {
    target: {
      value: 'OR',
    },
  },
  AND: {
    target: {
      value: 'AND',
    },
  },
};

const getSelectedClassName = (color) => `selected-${color}`;
const getStyleName = (leftRight, matchProperty, color, selectedValue) => {
  const suffix = `${leftRight}-${(matchProperty || selectedValue).toLowerCase()}`;
  const selected = matchProperty === selectedValue ? getSelectedClassName(color) : '';
  return `merit-scholarships-form-and-or-btn merit-scholarships-form-button-${suffix} ${color} ${selected}`;
};

const AndOrButtonSet = ({ index, matchKeyName, matchPropertyName, matchProperty, color, onChange }) => (
  <React.Fragment>
    <div styleName={`merit-scholarships-requirements-and-or-column ${color === 'red' ? 'nudge-it' : ''}`}>
      <button
        type="button"
        key={`scholarship-input-${matchKeyName}-match-and-${index}`}
        data-cy={`merit-scholarships-${matchKeyName}-match-and`}
        aria-label="Require both criteria to match"
        styleName={getStyleName('left', matchProperty, color, 'AND')}
        onClick={(e) => onChange(toggleAndOr.AND, matchPropertyName)}
        tabIndex={0}
      >
        AND
      </button>
      <button
        type="button"
        key={`scholarship-input-${matchKeyName}-match-or-${index}`}
        data-cy={`merit-scholarships-${matchKeyName}-match-or`}
        aria-label="Require one or the other criteria to match"
        styleName={getStyleName('right', matchProperty, color, 'OR')}
        onClick={(e) => onChange(toggleAndOr.OR, matchPropertyName)}
        tabIndex={0}
      >
        OR
      </button>
    </div>
  </React.Fragment>
);

AndOrButtonSet.propTypes = {
  index: PropTypes.string,
  matchKeyName: PropTypes.string,
  matchPropertyName: PropTypes.string,
  matchProperty: PropTypes.string,
  color: PropTypes.string,
  onChange: PropTypes.func,
};

export default AndOrButtonSet;
